/*نمای ساختمان*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={90.58}
      height={88.721}
      viewBox="0 0 90.58 88.721"
      {...props}
    >
      <g data-name="facade (1)">
        <path
          data-name="Rectangle 717"
          fill="#b4e1fa"
          d="M64.102 67.653h11.331v7.673H64.102z"
        />
        <path
          data-name="Rectangle 718"
          fill="#a0d2f0"
          d="M64.102 58.626h11.331v7.671H64.102z"
        />
        <path
          data-name="Path 7691"
          d="M37 58.626v27.609h16.581V58.626zm5.266 14.113a.679.679 0 11.2-.478.683.683 0 01-.2.478z"
          fill="#e4eaf6"
        />
        <path
          data-name="Rectangle 719"
          fill="#b4e1fa"
          d="M15.308 67.653h11.331v7.673H15.308z"
        />
        <path
          data-name="Rectangle 720"
          fill="#a0d2f0"
          d="M15.308 58.626h11.331v7.671H15.308z"
        />
        <path
          data-name="Rectangle 721"
          fill="#b4e1fa"
          d="M15.308 40.506h11.331v7.673H15.308z"
        />
        <path
          data-name="Rectangle 722"
          fill="#a0d2f0"
          d="M15.308 31.476h11.331v7.673H15.308z"
        />
        <path
          data-name="Rectangle 723"
          fill="#b4e1fa"
          d="M37 40.506h16.581v7.673H37z"
        />
        <path
          data-name="Rectangle 724"
          fill="#82b1e1"
          d="M37 31.476h16.581v7.673H37z"
        />
        <path
          data-name="Rectangle 725"
          fill="#b4e1fa"
          d="M64.102 40.506h11.331v7.673H64.102z"
        />
        <path
          data-name="Rectangle 726"
          fill="#82b1e1"
          d="M64.102 31.476h11.331v7.673H64.102z"
        />
        <path
          data-name="Path 7692"
          d="M67.728 4.277v8l11.169 5.595V4.277z"
          fill="#5b5d6e"
        />
        <path
          data-name="Path 7693"
          d="M45.29 2.567L2.562 23.95v5.751L44.99 8.467a.672.672 0 01.6 0l42.429 21.234V23.95z"
          fill="#707487"
        />
        <path
          data-name="Path 7694"
          d="M45.29 9.833L6.179 29.405v56.829h29.465V57.947a.679.679 0 01.678-.678h17.932a.679.679 0 01.678.678v28.287h29.465V29.405zM27.995 76.004a.679.679 0 01-.678.678H14.63a.679.679 0 01-.678-.678V57.947a.679.679 0 01.678-.678h12.687a.679.679 0 01.678.678zm0-27.147a.679.679 0 01-.678.678H14.63a.679.679 0 01-.678-.678v-18.06a.679.679 0 01.678-.678h12.687a.679.679 0 01.678.678zm26.942 0a.679.679 0 01-.678.678H36.322a.679.679 0 01-.678-.678v-18.06a.679.679 0 01.678-.678h17.932a.679.679 0 01.678.678zM76.79 76.004a.679.679 0 01-.678.678H63.424a.679.679 0 01-.678-.678V57.947a.679.679 0 01.678-.678h12.687a.679.679 0 01.678.678zm0-27.147a.679.679 0 01-.678.678H63.424a.679.679 0 01-.678-.678v-18.06a.679.679 0 01.678-.678h12.687a.679.679 0 01.678.678z"
          fill="#ffd782"
        />
        <path
          data-name="Path 7695"
          d="M90.505 23.532v7.264a1.811 1.811 0 01-2.618 1.619l-1-.5v53.189h1.883a1.809 1.809 0 010 3.617H1.809a1.809 1.809 0 010-3.617h1.883V31.915l-1 .5a1.81 1.81 0 01-2.617-1.619v-7.264a1.811 1.811 0 011-1.619L44.481.192a1.805 1.805 0 011.619 0l19.142 9.579V3.599A1.808 1.808 0 0167.05 1.79h12.529a1.81 1.81 0 011.809 1.809v14.247l8.118 4.063a1.811 1.811 0 01.999 1.623zm-3.617 4.336v-3.222L45.29 3.831 3.692 24.646v3.219l40.789-20.41a1.8 1.8 0 011.619 0zm-3.617 57.236v-55L45.29 11.097 7.309 30.104v55h27.2V57.946a1.81 1.81 0 011.809-1.809h17.941a1.81 1.81 0 011.808 1.809v27.158zm-5.5-69.058V5.407h-8.912v6.174zM52.45 85.104V59.756H38.13v25.348z"
        />
        <path
          data-name="Path 7696"
          d="M77.92 57.948v18.057a1.808 1.808 0 01-1.809 1.809H63.424a1.808 1.808 0 01-1.809-1.809V57.948a1.808 1.808 0 011.809-1.809h12.687a1.808 1.808 0 011.809 1.809zm-3.617 16.248v-5.412h-9.07v5.412zm0-9.03v-5.41h-9.07v5.41z"
        />
        <path
          data-name="Path 7697"
          d="M77.92 30.798v18.059a1.81 1.81 0 01-1.809 1.809H63.424a1.81 1.81 0 01-1.809-1.809V30.798a1.808 1.808 0 011.809-1.809h12.687a1.808 1.808 0 011.809 1.809zm-3.617 16.25v-5.412h-9.07v5.412zm0-9.03v-5.412h-9.07v5.412z"
        />
        <path
          data-name="Path 7698"
          d="M56.067 30.798v18.059a1.811 1.811 0 01-1.809 1.809H36.322a1.811 1.811 0 01-1.809-1.809V30.798a1.81 1.81 0 011.809-1.809h17.937a1.81 1.81 0 011.808 1.809zm-3.617 16.25v-5.412H38.13v5.412zm0-9.03v-5.412H38.13v5.412z"
        />
        <path
          data-name="Path 7699"
          d="M43.065 70.981a1.812 1.812 0 11-1.28-.529 1.82 1.82 0 011.28.529z"
        />
        <path
          data-name="Path 7700"
          d="M29.126 57.948v18.057a1.808 1.808 0 01-1.809 1.809H14.63a1.808 1.808 0 01-1.809-1.809V57.948a1.808 1.808 0 011.809-1.809h12.687a1.808 1.808 0 011.809 1.809zm-3.617 16.248v-5.412h-9.07v5.412zm0-9.03v-5.41h-9.07v5.41z"
        />
        <path
          data-name="Path 7701"
          d="M29.126 30.798v18.059a1.81 1.81 0 01-1.809 1.809H14.63a1.81 1.81 0 01-1.809-1.809V30.798a1.808 1.808 0 011.809-1.809h12.687a1.808 1.808 0 011.809 1.809zm-3.617 16.25v-5.412h-9.07v5.412zm0-9.03v-5.412h-9.07v5.412z"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
